"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapResourceV2Response = exports.mapResourceResponse = exports.mapCreateTag = exports.mapTagResponse = exports.mapResourceACLResponse = exports.mapResourceDomainResponse = exports.mapResourceProfileResponse = void 0;
const LocationClient_1 = require("./LocationClient");
const urls_1 = __importDefault(require("./urls"));
const mapResourceProfileResponse = (resourceProfileResponse) => ({
    id: resourceProfileResponse.id,
    email: resourceProfileResponse.email,
    name: resourceProfileResponse.name,
    thumbnailUrl: resourceProfileResponse.thumbnail_url,
    domainId: resourceProfileResponse.domain_id,
    domainRole: resourceProfileResponse.domain_role,
});
exports.mapResourceProfileResponse = mapResourceProfileResponse;
const mapResourceDomainResponse = (resourceDomainResponse) => ({
    id: resourceDomainResponse.id,
    name: resourceDomainResponse.id,
    description: resourceDomainResponse.id,
    adminProfile: (0, exports.mapResourceProfileResponse)(resourceDomainResponse.admin_profile),
});
exports.mapResourceDomainResponse = mapResourceDomainResponse;
const mapResourceACLResponse = (resourceACLResponse) => ({
    id: resourceACLResponse.id,
    resourceId: resourceACLResponse.resource_id,
    profileId: resourceACLResponse.profile_id,
    grantProfileId: resourceACLResponse.grant_profile_id,
    grantDomainId: resourceACLResponse.grant_domain_id,
    grantScope: resourceACLResponse.grant_scope,
    readGrant: resourceACLResponse.read_grant,
    updateGrant: resourceACLResponse.update_grant,
    deleteGrant: resourceACLResponse.delete_grant,
    shareGrant: resourceACLResponse.share_grant,
    fullGrant: resourceACLResponse.full_grant,
    customAccessGrants: resourceACLResponse.custom_access_grants,
    updatedAt: resourceACLResponse.updated_at,
    createdAt: resourceACLResponse.created_at,
    r: {
        profile: (0, exports.mapResourceProfileResponse)(resourceACLResponse.r.profile),
        grantProfile: resourceACLResponse.r.grant_profile
            ? (0, exports.mapResourceProfileResponse)(resourceACLResponse.r.grant_profile)
            : null,
    },
});
exports.mapResourceACLResponse = mapResourceACLResponse;
const mapTagResponse = (tagResponse) => ({
    id: tagResponse.id,
    key: tagResponse.key,
    label: tagResponse.label,
    resourceId: tagResponse.resource_id,
    type: tagResponse.type,
    value: tagResponse.value,
    createdAt: tagResponse.created_at,
});
exports.mapTagResponse = mapTagResponse;
const mapCreateTag = (tag) => ({
    type: tag.type,
    key: tag.key,
    label: tag.label,
    value: tag.value, // A typing error is present due to string | Day[] union on this property
});
exports.mapCreateTag = mapCreateTag;
const mapResourceResponse = (resourceResponse) => {
    var _a, _b;
    return ({
        id: resourceResponse.id,
        createdAt: resourceResponse.created_at,
        updatedAt: resourceResponse.updated_at,
        deletedAt: resourceResponse.deleted_at,
        lastActivityAt: resourceResponse.last_activity_at,
        parentFolderId: resourceResponse.parent_folder_id,
        profile: (0, exports.mapResourceProfileResponse)(resourceResponse.profile),
        domain: resourceResponse.domain
            ? (0, exports.mapResourceDomainResponse)(resourceResponse.domain)
            : null,
        r: {
            resourceACLs: (((_a = resourceResponse.r) === null || _a === void 0 ? void 0 : _a.resource_acls) || []).map(exports.mapResourceACLResponse),
            tags: (((_b = resourceResponse.r) === null || _b === void 0 ? void 0 : _b.tags) || []).map(exports.mapTagResponse),
        },
    });
};
exports.mapResourceResponse = mapResourceResponse;
const mapResourceV2Response = (resourceResponse) => {
    var _a;
    return {
        id: resourceResponse.id,
        profileId: resourceResponse.profile_id,
        domainId: resourceResponse.domain_id,
        parentFolderId: resourceResponse.parent_folder_id,
        createdAt: resourceResponse.created_at,
        updatedAt: resourceResponse.updated_at,
        deletedAt: resourceResponse.deleted_at,
        r: {
            // NOTE: resourceResponse.r will not exist for device published content until the
            // user published after deploying rules and tags. Afterwhich, it's guaranteed to exist.
            // We need to leave 'r?' for backwards compatibility until all devices have been published
            // since deploying rules and tags.
            tags: (((_a = resourceResponse.r) === null || _a === void 0 ? void 0 : _a.tags) || []).map(exports.mapTagResponse),
        },
    };
};
exports.mapResourceV2Response = mapResourceV2Response;
class ResourceClient {
    createResourceACL(acl) {
        return __awaiter(this, void 0, void 0, function* () {
            const grant_profile_id = 'grantProfileId' in acl ? acl.grantProfileId : undefined;
            const grant_profile_email = 'grantProfileEmail' in acl ? acl.grantProfileEmail : undefined;
            const parts = {
                resource_id: acl.resourceId,
                grants: acl.grants,
            };
            const body = grant_profile_id
                ? Object.assign(Object.assign({}, parts), { grant_profile_id }) : Object.assign(Object.assign({}, parts), { grant_profile_email });
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.resourceACLs(),
                body,
            });
            return (0, exports.mapResourceACLResponse)(data);
        });
    }
    deleteResourceACL(aclId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.resourceACL(aclId),
            });
        });
    }
    listResourceACLs(resourceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.listResourceACLs(resourceId),
            });
            return data.map((acl) => (0, exports.mapResourceACLResponse)(acl));
        });
    }
    // V5 methods
    createResourceACLV5(reqBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.resourceACLV5(reqBody.resourceId),
                body: {
                    resource_id: reqBody.resourceId,
                    grant_profile_ids: 'grantProfileIds' in reqBody ? reqBody.grantProfileIds : [],
                    grant_domain_id: 'grantDomainId' in reqBody ? reqBody.grantDomainId : '',
                    grants: reqBody.grants,
                },
            });
            const acl = data.acl || [];
            return acl.map((acl) => (0, LocationClient_1.mapLocationACLResponse)(acl));
        });
    }
    updateResourceACLV5(reqBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PUT',
                url: urls_1.default.resourceACLV5(reqBody.resourceId),
                body: {
                    resource_id: reqBody.resourceId,
                    grant_profile_ids: 'grantProfileIds' in reqBody ? reqBody.grantProfileIds : [],
                    grant_domain_id: 'grantDomainId' in reqBody ? reqBody.grantDomainId : '',
                    grants: reqBody.grants,
                },
            });
            const acl = data.acl || [];
            return acl.map((acl) => (0, LocationClient_1.mapLocationACLResponse)(acl));
        });
    }
    deleteResourceACLV5(resourceId, reqBody) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.resourceACLV5(resourceId),
                body: {
                    grant_profile_ids: 'grantProfileIds' in reqBody ? reqBody.grantProfileIds : [],
                    grant_domain_id: 'grantDomainId' in reqBody ? reqBody.grantDomainId : '',
                },
            });
        });
    }
}
exports.default = ResourceClient;
